(function () {
  var namespace = window.PlaudSigmaHeroBreath || (window.PlaudSigmaHeroBreath = {});

  if (namespace.init) {
    namespace.init(document);
    return;
  }

  var controllers = new WeakMap();
  var selector = '.sigma-hero[data-breath-enabled="on"]';

  function setBreath(hero, active) {
    hero.setAttribute('data-breath', active ? 'on' : 'off');
  }

  function buildController(hero) {
    var isIntersecting = true;
    var observer = null;

    function shouldRun() {
      return isIntersecting && document.visibilityState !== 'hidden';
    }

    function sync() {
      setBreath(hero, shouldRun());
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target !== hero) return;
          isIntersecting = entry.isIntersecting || entry.intersectionRatio > 0;
          sync();
        });
      }, { threshold: 0.01 });
      observer.observe(hero);
    }

    document.addEventListener('visibilitychange', sync);
    sync();

    return {
      destroy: function () {
        document.removeEventListener('visibilitychange', sync);
        if (observer) observer.disconnect();
      }
    };
  }

  function collectHeroes(root) {
    var scope = root || document;
    var heroes = [];

    if (scope.matches && scope.matches(selector)) {
      heroes.push(scope);
    }

    if (scope.querySelectorAll) {
      Array.prototype.forEach.call(scope.querySelectorAll(selector), function (hero) {
        heroes.push(hero);
      });
    }

    return heroes;
  }

  function init(root) {
    collectHeroes(root).forEach(function (hero) {
      if (controllers.has(hero)) return;
      controllers.set(hero, buildController(hero));
    });
  }

  function destroy(root) {
    collectHeroes(root).forEach(function (hero) {
      var controller = controllers.get(hero);
      if (!controller) return;
      controller.destroy();
      controllers.delete(hero);
    });
  }

  namespace.init = init;
  namespace.destroy = destroy;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });
})();
